<template>
  <div id="leftNav">
    <h3>{{ title }}</h3>
    <ul class="navList">
      <li
        v-for="(top, topIndex) in topNav"
        :key=top.Code
        @mouseenter="handleMouseEnter(topIndex)"
        @mouseleave="handleMouseLeave()">
        <a
          :href="getNavUrl(top.Url, top.CategoryCode, top.PropertyCondition)">{{ top.Name }}
        </a>
        <div class="secNav" v-if="secNav[topIndex].length" v-show="topIndex === currentIndex">
          <div v-for="(item, secIndex) in secNav[topIndex]" :key=item.Code>
            <a
              :key=item.Code
              :href="getNavUrl(item.Url, item.CategoryCode, item.PropertyCondition)"
            >{{ item.Name }}</a>
            <i v-show="secIndex !== secNav[topIndex].length - 1">|</i>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import jsonp from 'js/jsonp.js'
import { objCompare } from 'js/compare.js'
export default {
  name: 'common-leftNav',
  data () {
    return {
      topNav: [],
      secNav: [],
      currentIndex: -1
    }
  },
  props: {
    title: String,
    navCode: String
  },
  computed: {
    getNavUrl () {
      return function (url, CategoryCode, PropertyCondition) {
        return url === '' ? `http://souke.xdf.cn/Category/${this.$store.state.soukecityId}-${CategoryCode}-${PropertyCondition !== '' ? PropertyCondition : 0}-0.html?v=5` : url
      }
    },
    cityId () {
      return this.$store.state.soukecityId
    }
  },
  watch: {
    cityId (newVal) {
      this.getAllNavData(newVal)
    }
  },
  created () {
    this.getAllNavData()
  },
  methods: {
    getAllNavData () {
      jsonp('http://deploy.xdf.cn/api/Soukeapi/souke', {
        method: 'NavCategory/GetNavCategoryByCity',
        param: JSON.stringify({cityId: this.$store.state.soukecityId})
      }).then(res => {
        this.getTopNav(res)
      })
    },
    getTopNav (res) {
      let _this = this
      let code = ''
      res.filter(function (item, index) {
        if (item.CategoryCode === _this.navCode && item.Depth === 1) {
          code = item.Code
        }
      })
      res.filter(function (item, index) {
        if (item.ParentCode === code && item.Depth === 2) {
          _this.topNav.push(item)
        }
      })
      this.topNav.sort(objCompare('SortIndex'))
      this.getSecNav(_this.topNav, res)
    },
    getSecNav (res, alldata) {
      let _this = this
      res.forEach((resItem, resIndex) => {
        let tempArr = []
        alldata.filter(function (item, index) {
          if (item.ParentCode === resItem.Code) {
            tempArr.push(item)
          }
        })
        tempArr.sort(objCompare('SortIndex'))
        _this.secNav.push(tempArr)
      })
    },
    getThirdNav (res, alldata) {
      let _this = this
      res.forEach((resItem, resIndex) => {
        let tempArr = []
        alldata.filter(function (item, index) {
          if (item.ParentCode === resItem.Code) {
            tempArr.push(item)
          }
        })
        tempArr.sort(objCompare('SortIndex'))
        _this.secNav.push(tempArr)
      })
      console.log(_this.secNav)
    },
    handleMouseEnter (index) {
      this.currentIndex = index
    },
    handleMouseLeave () {
      this.currentIndex = -1
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
#leftNav
  width: 175px
  color: $fontcolor
  position: $rel
  float: $fl
  margin-right:10px
  h3
    background: $mainNavTitleColor
    height: 40px
    font-size: 16px
    line-height: 40px
    position: $rel
    padding-left: 20px
  .navList
    background: $mainNavBodyColor
    min-height: 360px
    border-left: 1px solid $mainNavBodyColor
    li
      font-size: 12px
      height: 36px
      line-height: 36px
      padding: 2px 0 2px 20px
      cursor: pointer
      &:hover
        background: #fff
        padding-left: 27px
        transition: padding-left .3s
      &:hover > a
          color: $themeColor
      & > a
        color: #fff
        overflow: hidden
        height: 40px
  .secNav
    position: $abs
    height: 338px
    top: 40px
    left: 175px
    background: $fontcolor
    width: 590px
    padding: 10px
    border: 1px solid $bdcolor
    z-index: 99999
    border-left-color: transparent
    div
      float: $fl
      line-height: 0
      a
        line-height: 20px
        padding: 5px 0
        font-size: 12px
        &:hover
          color: $themeColor
      i
        color: #ccc
        margin: 0 9px
</style>



// WEBPACK FOOTER //
// src/common-components/Channelleftnav.vue